(function() {
    'use strict';

    angular
        .module('elogbooks.common.partnership')
        .controller('AssociateTypesAddController', AssociateTypesAddController);

    AssociateTypesAddController.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        'apiClient',
        'siteAssociateStateService',
        'siteAssociateTypeCollectionExcludeExistingResponse'
    ];

    function AssociateTypesAddController(
        $scope,
        $state,
        $stateParams,
        apiClient,
        siteAssociateStateService,
        siteAssociateTypeCollectionExcludeExistingResponse
    ) {
        var vm = this;
        vm.selectedAssociateTypes = [];
        vm.disableSubmit = false;
        vm.addAssociates = $stateParams.addAssociates || [];

        vm.associateTypesSelect = {
            link: siteAssociateTypeCollectionExcludeExistingResponse.getLink('self'),
            response: siteAssociateTypeCollectionExcludeExistingResponse,
            required: true,
            responseKeyPath: 'siteAssociateTypes',
            itemHrefPath: '_links.self.href',
        };

        // Types the dropdown has offered so far, keyed by id. The resolved response only holds the
        // first page, but the multi-select swaps its response out when searching and pushes into it
        // on 'load more' - so selections have to be resolved against everything seen, not the resolve.
        const knownAssociateTypes = new Map();

        function registerAssociateTypes(associateTypes) {
            (associateTypes || []).forEach(associateType => {
                if (associateType && associateType.id && !knownAssociateTypes.has(associateType.id)) {
                    knownAssociateTypes.set(associateType.id, associateType);
                }
            });
        }

        registerAssociateTypes(siteAssociateTypeCollectionExcludeExistingResponse.siteAssociateTypes);

        $scope.$watchCollection(
            () => vm.associateTypesSelect.response ? vm.associateTypesSelect.response.siteAssociateTypes : null,
            registerAssociateTypes
        );

        vm.addAction = function() {
            const addAssociates = vm.selectedAssociateTypes.reduce((acc, selected) => {
                siteAssociateStateService.removeRemovedAssociateType(selected.id);

                const associateType = knownAssociateTypes.get(selected.id);

                if (!associateType) {
                    console.error('Selected site associate type not found in loaded options', selected);
                    return acc;
                }

                acc.push({...associateType, expanded: true, checked: false});
                return acc;
            }, []);

            $state.go('^',
                { addAssociates: [...vm.addAssociates, ...addAssociates] },
                { reload: true }
            );
        }

        vm.cancelAction = function() {
            $state.go('^',
                { addAssociates: vm.addAssociates.map(item => ({...item, expanded: true, checked: false})) },
                { reload: true }
            );
        }
    }
})();
